var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHuman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.35 6.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M84 196h24v24H84z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -22.225 -51.858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.5 202h-2c-1.93 0-3.5 1.57-3.5 3.5v4c0 1.391.822 2.585 2 3.149V219a1 1 0 0 0 2 0v-6h1v6a1 1 0 0 0 2 0v-6.351a3.5 3.5 0 0 0 2-3.149v-4c0-1.93-1.57-3.5-3.5-3.5m-3.5-3.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m-5 0a2.5 2.5 0 0 1 2.5-2.5c.402 0 .777.104 1.114.273A4.44 4.44 0 0 0 99 198.5c0 .814.234 1.568.615 2.227A2.5 2.5 0 0 1 98.5 201a2.5 2.5 0 0 1-2.5-2.5m-5 0a2.5 2.5 0 0 1 2.5-2.5c.402 0 .777.104 1.114.273A4.44 4.44 0 0 0 94 198.5c0 .814.234 1.568.615 2.227A2.5 2.5 0 0 1 93.5 201a2.5 2.5 0 0 1-2.5-2.5m-5 0a2.5 2.5 0 0 1 2.5-2.5c.402 0 .777.104 1.114.273A4.44 4.44 0 0 0 89 198.5c0 .814.234 1.568.615 2.227A2.5 2.5 0 0 1 88.5 201a2.5 2.5 0 0 1-2.5-2.5m12.261 3.5A5.48 5.48 0 0 0 97 205.5V218a1 1 0 0 1-2 0v-6.051a3.52 3.52 0 0 1-1-2.449v-4c0-1.93 1.57-3.5 3.5-3.5zm-5 0c-.787.952-1.261 1.172-1.261 2.5V216a1 1 0 0 1-2 0v-5.051a3.52 3.52 0 0 1-1-2.449v-3c0-1.93 1.57-3.5 3.5-3.5zm-5 0c-.787.952-1.261 1.172-1.261 2.5v9.5a1 1 0 0 1-2 0v-4.051a3.52 3.52 0 0 1-1-2.449v-2c0-1.93 1.57-3.5 3.5-3.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuman);
export default __webpack_public_path__ + "static/media/human.0ff4bcfb2a0350b8b948c54c32f00423.svg";
export { ForwardRef as ReactComponent };